const entity = 'secretaries'
const entitySingle = 'secretary'
const tableIcon = 'cil-people'

export {
  entity,
  entitySingle,
  tableIcon
}
